"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinkUnionUnsafe = exports.isLinkUnion = void 0;
const StandardLink_1 = require("./StandardLink");
const RolAdapterLink_1 = require("./RolAdapterLink");
const RolAutoglideLink_1 = require("./RolAutoglideLink");
const RolLink_1 = require("./RolLink");
const RolModifiedLink_1 = require("./RolModifiedLink");
const isLinkUnion = (whatever, v) => (0, StandardLink_1.isStandardLink)(whatever, v) ||
    (0, RolLink_1.isRolLink)(whatever, v) ||
    (0, RolAdapterLink_1.isRolAdapterLink)(whatever, v) ||
    (0, RolModifiedLink_1.isRolModifiedLink)(whatever, v) ||
    (0, RolAutoglideLink_1.isRolAutoglideLink)(whatever, v);
exports.isLinkUnion = isLinkUnion;
const isLinkUnionUnsafe = (whatever, v) => (0, StandardLink_1.isStandardLinkUnsafe)(whatever, v) ||
    (0, RolLink_1.isRolLinkUnsafe)(whatever, v) ||
    (0, RolAdapterLink_1.isRolAdapterLinkUnsafe)(whatever, v) ||
    (0, RolModifiedLink_1.isRolModifiedLinkUnsafe)(whatever, v) ||
    (0, RolAutoglideLink_1.isRolAutoglideLinkUnsafe)(whatever, v);
exports.isLinkUnionUnsafe = isLinkUnionUnsafe;
//# sourceMappingURL=LinkUnion.js.map